import l2 from './layout2.js';
export default {
  l2: l2
};